import { IconButton, TextButton } from '@creditornot/cb-button';
import { MagnifyingGlass, MoreHorizontal, Plus } from '@creditornot/cb-icons';
import { Input } from '@creditornot/cb-input';
import { MenuItemGroup, MenuLinkItem } from '@creditornot/cb-menu';
import { LegacyPopover } from '@creditornot/cb-popover';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { PickingArea } from 'apis/picker-api/types';

import { PickingState } from '../hooks/usePickingAreas';

type TopActionsProps = {
  customAreas?: PickingArea[];
  state: PickingState;
  searchInput: string;
  setSearchInput: (searchInput: string) => void;
  dispatchModalAction: (action: any) => void;
};

const TopActionsContainer = styled.div`
  display: flex;
  align-items: center;
`;

const SearchInput = styled(Input)`
  margin-inline-end: 16px;
`;

const StyledPopover = styled(LegacyPopover)`
  margin-inline-start: 16px;
`;

const PopoverContent = styled(MenuItemGroup)`
  padding: 0 8px;
`;

export const TopActions = ({
  customAreas,
  state,
  searchInput,
  setSearchInput,
  dispatchModalAction,
}: TopActionsProps) => {
  const { formatMessage } = useIntl();
  return (
    <TopActionsContainer>
      <SearchInput
        onClearClick={() => setSearchInput('')}
        value={searchInput || ''}
        onChange={e => setSearchInput(e.currentTarget.value)}
        placeholder={formatMessage({ id: 'picking-route.search-all-items' })}
        icon={<MagnifyingGlass />}
      />
      <TextButton
        variant="brand"
        icon={<Plus />}
        disabled={state !== 'settled'}
        onClick={() => dispatchModalAction({ type: 'create-area-start', itemsToAssign: [] })}
      >
        <FormattedMessage id="picking-route.create-new" />
      </TextButton>
      <StyledPopover
        showOnClick
        showOnHover={false}
        renderArrow={false}
        portalElement={null}
        contentZIndex={1}
        placement="bottom-start"
        closeOnClickInside
        disabled={state !== 'settled' || customAreas?.length === 0}
        content={
          <PopoverContent>
            <MenuLinkItem
              variant="red"
              onClick={() =>
                dispatchModalAction({
                  type: 'delete-area-start',
                  areaIdsToDelete: customAreas?.map(area => area.id) || [],
                })
              }
            >
              <FormattedMessage id="picking-route.delete-all-areas" />
            </MenuLinkItem>
          </PopoverContent>
        }
      >
        <IconButton variant="brand" size="small" disabled={state !== 'settled' || customAreas?.length === 0}>
          <MoreHorizontal />
        </IconButton>
      </StyledPopover>
    </TopActionsContainer>
  );
};
